import { createAction } from '@reduxjs/toolkit'

export const signOutAction = createAction('auth/signOut')
